import { useRef } from "react";
import { Button, TextField } from "@mui/material";
import { tss } from "tss-react";
import { api } from "api/Call";
import {CommonDialogBox} from "components";
import { config } from "config";
import { updateData } from "services/CacheService";

const useStyles = tss.create(() => ({
    title: {
        fontSize: 16,
        fontWeight: "bold",
        marginBottom: 20,
    },
    header: {
        fontSize: 12,
        color: "rgba(0,0,0,0.55)",
    },
    margin: {
        marginTop: -5,
    },
    button: {
        minWidth: 20,
        padding: "5px 5px",
        marginLeft: 5,
        width: 75,
        height: 36,
    },
    bottom: {
        position: "absolute",
        top: "calc(100% - 49px)",
        right: 22,
    },
    nextButton: {
        fontWeight: "bold",
    },
    cancelButton: {
        right: 14,
        fontWeight: "bold",
    },
    textField: {
        width: 300,
    },
    m24: {
        margin: '2.4rem'
    },
    rounded8: {
        borderRadius: '.8rem'
    },
    whitebg: {
        backgroundColor: '#fff'
    },
    gap12: {
        gridGap: '1.2rem',
        gap: '1.2rem'
    }
}));

type IProps = {
    open: boolean;
    catalog: any;
    handleClose: (cancelled: boolean) => void;
    title?: string
};

export default function RenameItemPanel(props: IProps) {
    const { classes } = useStyles();
    const { catalog, open, title:dialogBoxTitle } = props;
    const inputRef = useRef<HTMLDivElement | null>(null);
    const entity = catalog && catalog.entity ? catalog.entity : catalog;
    let newValue: string;

    const handleCancel = () => {
        props.handleClose(false);
    };

    const onFocus = () => {
        inputRef?.current?.focus();
    };

    const handleOk = () => {
        sendData(entity.project, entity.ID, newValue);
        props.handleClose(true);
    };

    const handleChange = (event: any) => {
        newValue = event.target.value;
    };

    const handleKeyPress = (event: any) => {
        if (event.key === "Enter") {
            handleOk();
        }
    };
    

    const DialogAction = () => {
        return (
            <>
                <Button
                    type="button"
                    color="primary"
                    variant="outlined"
                    fullWidth
                    onClick={(e) => {
                        handleCancel();
                    }}
                    sx={{
                        width: 85
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    fullWidth
                    onClick={(e) => {
                        handleOk();
                    }}
                    sx={{
                        width: 85
                    }}
                >
                    Rename
                </Button>
            </>
        )
    }

    function sendData(catalogID: string, itemID: string, itemName: string) {
        const body = {
            name: itemName,
        };
        api(`${config.api.endpoints["entity"]}?id=${itemID}&project=${catalogID}`, { body: body })
            .then((entries: any) => {
                //console.log("then");
                //console.log(entries);
                updateData("update", "entities", entity.project, {
                    ...entity,
                    name: itemName,
                }, (id: string) => {});
            })
            .catch((error: any) => {
                //console.error("catch");
                //console.error(error);
            });
    }

    /*return (
        <ModalWindow
            handleClose={handleCancel}
            width={500}
            height={200}
            minHeight={"fit-content"}
            open={open}
            onFocus={onFocus}
        >
            <Typography className={classes.title}>Rename</Typography>
            <TextField
                id="rename-item-name"
                label="Name"
                className={classes.textField}
                onChange={handleChange}
                defaultValue={entity?.name}
                inputRef={inputRef}
                onKeyPress={handleKeyPress}
                inputProps={{ "aria-label": "Name" }}
            />
            <div className={classes.bottom}>
                <Button
                    onClick={(e) => {
                        handleCancel();
                    }}
                    className={[classes.button, classes.cancelButton].join(" ")}
                >
                    Cancel
                </Button>
                <Button
                    onClick={(e) => {
                        handleOk();
                    }}
                    className={[classes.button, classes.nextButton].join(" ")}
                >
                    Rename
                </Button>
            </div>
        </ModalWindow>
    );*/
    
    return (
        <CommonDialogBox
			classes={{
				paper: `${classes.m24} ${classes.rounded8} ${classes.whitebg}`
			}}
			open={open}
			handleClose={handleCancel}
            subtitle1={dialogBoxTitle || 'Rename' }
            actionClasses={`${classes.gap12}`}
            dialogAction={<DialogAction />}
		>
            <TextField
                id="rename-item-name"
                label="Name"
                //className={classes.textField}
                onChange={handleChange}
                defaultValue={entity?.name}
                inputRef={inputRef}
                size="small"
                fullWidth
                onKeyPress={handleKeyPress}
                inputProps={{ "aria-label": "Name" }}
            />
        </CommonDialogBox>
    );
}
